<template>
	<div id='assistant' 
	class="assistant" 
	v-if='content.Content' 
	:data-hide='hide' 
	@touchstart.stop="touchStart"
	@touchmove.prevent.stop="touchMove"
	@touchend.stop="touchEnd"
	>
		<div v-html='content.Content'></div>
		<!-- <div class="narrow" @click='narrow'></div> -->
		<div class="cover" v-if='hide' @click='narrow'></div>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				content:{},
				hide:false,
				start_p:{x:0,y:0},
				diff_p:{x:0,y:0},
			}
		},
		props:{
			Code:{
				type:String,
				default:'Assistant'
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{
		},
		mixins:[],
		components: {

		},
		computed: {
			...mapState({

			}),
		},
		methods: {
			...mapActions([
				'getCommunityArticleAction',
			]),
			async initData(){
				this.content = await this.getCommunityArticleAction({Code:this.Code})
			},
			narrow(){
				this.hide = !this.hide
			},
			touchStart(e) {
				let touch = e.touches[0]
				this.start_p = {
					x:touch.clientX,
					y:touch.clientY,
				}
			},
			touchMove(e) {
				let touch = e.touches[0]
				this.diff_p = {
					x:touch.clientX - this.start_p.x,
					y: touch.clientY - this.start_p.y,
				}
			},
			touchEnd(e){
				if (this.diff_p.x > 10) {
					this.hide = true
					this.diff_p = this.start_p = {x:0,y:0}
				}
			}
		},
	}
</script>

<style lang='scss' scoped>
	.assistant {
		z-index: 9999;
		cursor: pointer;
		box-shadow: 3px 3px 5px 1px rgba(0,0,0,.2);
		background-color: white;
		padding:10px 1.56vw;
		width: 10vw;
		// right:0;
		min-width:140px;
		.title {
			text-align: center;
		}
		transition: all .25s ease;
		&[data-hide=true] {
			width: 40px;
			height:40px;
			overflow: hidden;
			min-width:40px;
			right:-20px;
			border-radius: 20px;
		}
		.cover {
			background-image: url('../../assets/open.png');
			background-size: contain;
			background-color: rgba(255,255,255,0.6);
			width: 100%;
			height:100%;
			position:absolute;
			top: 0;
			left: 0;
		}
		.narrow {
			display:none;
		}
	}
@media (max-width: 768px){
	.assistant {
		&[data-hide=true] {
			.narrow {
				display:none;
			}
		}
		.narrow {
			display:block;
			width: 25px;
			height:25px;
			position:absolute;
			right: 0;
			top: 10px;
			background-image: url('../../assets/narrow.png');
			background-size: contain;
			background-color: rgba(255,255,255,0.7);
		}
	}
}
</style>